import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function LegalEntityDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [entity, setEntity] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get(`/LegalEntity/${id}`)
            .then(res => setEntity(res.data))
            .catch(() => setError("Failed to load entity"));
    }, [id]);

    if (error) return <p className="text-red-500">{error}</p>;
    if (!entity) return <p>Loading...</p>;

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">
                {entity.companyName}
            </h2>

            <p><b>Tax ID:</b> {entity.taxId || "�"}</p>
            <p><b>Registration:</b> {entity.registrationNumber || "�"}</p>
            <p><b>Contact Person:</b> {entity.contactPerson || "�"}</p>
            <p><b>Phone:</b> {entity.companyPhone || "�"}</p>

            <p><b>Address:</b></p>
            <p>
                {entity.manualCountry}, {entity.manualCity} <br />
                {entity.manualAddress}, {entity.manualPostalCode}
            </p>

            <button
                className="mt-4 bg-gray-300 px-4 py-2 rounded"
                onClick={() => navigate("/admin/legal")}
            >
                Back
            </button>
        </div>
    );
}